<template>
  <div>
    <div class="banner">
      <h4>{{ title }}</h4>
    </div>

    <v-form @submit.prevent="create" ref="form">
        <v-row dense>
            <v-col class="d-flex flex-column align-center justify-center" cols="12" sm="12">
                <p>Unidade Transplantadora?<span style="color: red;">*</span></p>
                <v-radio-group v-model="centroForm.transplanted_orgon_flg" row>
                    <v-radio
                        label="Sim"
                        value="1"
                    ></v-radio>
                    <v-radio
                        label="Não"
                        value="0"
                    ></v-radio>
                </v-radio-group>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
                <v-text-field
                    class="rounded-lg"
                    color="#41916b"
                    outlined v-model="centroForm.cnes"
                    type="number"
                    v-mask="'#######'"
                    :rules="formRules"
                    dense>
                    <template v-slot:label>
                        CNES <span style="color: red;">*</span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
                <v-autocomplete
                    :items="municipies"
                    item-text="nome"
                    item-value="nome"
                    class="rounded-lg"
                    color="#41916b"
                    outlined
                    v-model="centroForm.municipality"
                    :rules="formRules"
                    dense>
                    <template v-slot:label>
                        Município <span style="color: red;">*</span>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col class="d-flex" cols="12" sm="12">
                <v-text-field
                    class="rounded-lg"
                    color="#41916b"
                    outlined
                    v-model="centroForm.hospital"
                    :rules="formRules"
                    dense>
                    <template v-slot:label>
                        Nome da Unidade de Saúde <span style="color: red;">*</span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
                <v-text-field
                    class="rounded-lg"
                    color="#41916b"
                    outlined
                    v-model="centroForm.type_of_establishment"
                    :rules="formRules"
                    dense>
                    <template v-slot:label>
                        Tipo de Estabelecimento<span style="color: red;">*</span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
                <v-text-field
                    class="rounded-lg"
                    color="#41916b"
                    outlined
                    v-model="centroForm.administrative_sphere"
                    :rules="formRules"
                    dense>
                    <template v-slot:label>
                        Esfera Administrativa<span style="color: red;">*</span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
                <v-select
                    :items="opos"
                    item-text="description"
                    item-value="id"
                    class="rounded-lg"
                    color="#41916b"
                    outlined
                    v-model="centroForm.opo_reference_id"
                    :rules="formRules"
                    dense>
                    <template v-slot:label>
                        OPO<span style="color: red;">*</span>
                    </template>
                </v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
                <v-select
                    :items="opcs"
                    item-text="description"
                    item-value="id"
                    class="rounded-lg"
                    color="#41916b"
                    outlined
                    v-model="centroForm.opc_reference_id"
                    :rules="formRules"
                    dense>
                    <template v-slot:label>
                        OPC<span style="color: red;">*</span>
                    </template>
                </v-select>
            </v-col>
            <v-col class="d-flex" cols="12" sm="12" v-if="centroForm.transplanted_orgon_flg == '1'">
                <v-select
                    :rules="perfilRules"
                    :items="orgons"
                    v-model="centroForm.link_orgons"
                    item-text="name"
                    item-value="id"
                    dense
                    multiple
                    outlined
                    chips
                    color="#41916b"
                    class="rounded-lg"
                    label="Orgãos">
                </v-select>
            </v-col>
        </v-row>

      <v-card-actions class="cardFooter">
          <v-spacer></v-spacer>
            <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
              <span>{{$t('buttons.cancel')}}</span>
            </v-btn>

            <v-btn class="rounded-lg" color="blue" text elevation="0" @click="$refs.form.reset()">
              <span>{{$t('buttons.clean_up')}}</span>
            </v-btn>

            <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
              <span class="textBtn">{{ btnMessage }}</span>
              <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
            </v-btn>
      </v-card-actions>
    </v-form>

  </div>
</template>

<script>
import { getAllOrgons, getMunicipalities, getOpoReferences, getOpcReferences, saveUnity } from "@/service/basic-registrations/UnitiesService";
import { mapActions } from "vuex";
import Formatters from "@/utils/Formatters";
export default {
  data() {
    return {
        dialog: false,
        formRules: [(v) => !!v || "O campo é obrigatório"],
        loading: false,
        orgons: [],
        municipies: [],
        opos: [],
        opcs: [],
      };
  },

  props: {
      centroForm: {
        type: Object,
      },
    },

  computed: {
    title() {
      return this.centroForm.id ? 'Atualizar Unidade Hospitalar' : 'Nova Unidade Hospitalar';
    },

    btnMessage() {
      return this.centroForm.id ? 'Atualizar' : 'Salvar';
    }
  },

  watch: {
    'centroForm': {
        handler(item) {
            this.centroForm.link_orgons = item.unity_orgons.map(item => parseInt(item.orgon_id));
            this.centroForm.opo_reference_id = parseInt(item.opo_reference_id)
            this.centroForm.opc_reference_id = parseInt(item.opc_reference_id)
        },

        immediate: true,
    }
  },

  mounted() {
    this.getFields();
  },

  methods: {
    ...mapActions([
      "changeSnackBarData",
    ]),

    getFields() {
      getMunicipalities().then((result) => { this.municipies = result; });
      getAllOrgons().then((result) => { this.orgons = result; });
      getOpoReferences().then((result) => { this.opos = result; });
      getOpcReferences().then((result) => { this.opcs = result; });
    },

    create() {
      this.loading = true;
      if (this.$refs.form.validate()) {

        const dados = {
          transplanted_orgon_flg: this.centroForm.transplanted_orgon_flg,
          CNES: this.centroForm.cnes,
          opo_reference_id: this.centroForm.opo_reference_id,
          opc_reference_id: this.centroForm.opc_reference_id,
          hospital: this.centroForm.hospital,
          municipality: this.centroForm.municipality,
          type_of_establishment: this.centroForm.type_of_establishment,
          administrative_sphere: this.centroForm.administrative_sphere,
          link_orgons: this.centroForm.link_orgons
        }

        saveUnity(this.centroForm.id || null, dados).then((response) => {
            this.loading = false;
            this.changeSnackBarData({
                status: true,
                type: 'success',
                titleMessage: response.data.message,
                bodyMessage: '',
                cardColor: 'success',
                titleIcon: 'mdi-check-circle',
            });

            setTimeout(() => {
              this.closeSnackBar();
              this.closeDialog();
            }, 3000);

          }).catch((err) => {
            this.loading = false;

            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: Formatters.formatErrorMessage(err),
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },

    closeDialog() {
      this.$emit("closeDialog");
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.centroForm = {}
    },

    closeSnackBar() {
        this.changeSnackBarData({
            status: false,
            type: '',
            titleMessage: '',
            bodyMessage: '',
            cardColor: '',
            titleIcon: '',
        });
    }
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  margin-bottom: 20px;
}

.space {
  width: 15px;
}
.spacediferent {
  width: 7px;
}

.unity{
  font-size: 12px;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.0125em;
    font-family: 'Roboto';
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.create-user-dialog {
  padding: 20px;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

.cardFooter {
  padding: 0 !important;
}
</style>
